import Sortable from "sortablejs"
import { xhr, toast, wait, sortElementsForSortable } from "$app/utils"
import { appStore } from "$app/store.svelte"

const pages = ["department", "assignee", "hierarchy", "my_progress"]
function createPage() {
  // const { subscribe, set, update } = writable("department")
  // return {
  //   subscribe,
  //   setPage: (newPage) => {
  //     if (pages.includes(newPage)) {
  //       update((p) => (p = newPage))
  //     }
  //   },
  //   reset: () => set("department")
  // }
}
export const page = createPage()

// export const draggedElement = writable({
//   id: 0,
//   type: "",
//   goal_id: 0,
//   assignee_id: 0,
//   assignee_type: ""
// })

// export const dropElement = writable({
//   id: 0,
//   type: "",
//   goal_id: 0,
//   assignee_id: 0,
//   assignee_type: ""
// })

export function sortGoalsOrder(newGoals: GoalType[]) {
  console.log("setgoalsorder")
  // const goalsStore = get(goals)
  // newGoals.forEach((goal) => {
  //   const idx = goalsStore.findIndex((g) => g.id === goal.id)
  //   goals.update((gs) => {
  //     gs[idx] = { ...goalsStore[idx], ...goal }
  //     return gs
  //   })
  // })
}

/**
 * Async function that updates goals
 */
export async function updateGoalsOrder(
  newGoals: GoalType[],
  goal_id: number
): Promise<void> {
  const plan_id = newGoals[0].plan_id

  console.log("updateGoalsOrder")
  try {
    const resp = await xhr.post<{ goals: GoalType[] }>(
      `/plans/${plan_id}/goals/sort_by_parent.json`,
      {
        goals: newGoals.map((g) => g.id),
        id: goal_id
      }
    )

    sortGoalsOrder(resp.data.goals)
  } catch (e) {
    toast("There was an error goals tasks", "error")
    console.error(e)

    const tempGoals = [...appStore.goals]

    await wait(20)
    appStore.goals = tempGoals
  }
}

type gType = "AnnualGoal" | "QuarterlyGoal"

export const parentTypes = {
  AnnualGoal: "LongTermGoal",
  QuarterlyGoal: "AnnualGoal"
}
// Stub for now
function get(element: any) {
  return element
}

function set(element: any) {
  return element
}

/**
 * Creates sortable for goals
 */
export function setSortable(
  sortableSelection: HTMLElement,
  goalType: gType
): void {
  if (!sortableSelection) return

  const sort = Sortable.create(sortableSelection, {
    animation: 200,
    group: goalType,
    scrollSensitivity: 150,
    delay: 400,
    delayOnTouchOnly: true,
    direction: "vertical",
    ghostClass: "opacity-50",
    dragClass: "border-green-400",
    emptyInsertThreshold: 20,
    removeCloneOnHide: false,
    onEnd: async (e: EventSortType) => {
      const goalsS = get(appStore.goals)
      const dropElementS = get(appStore.dropElement)
      const draggedElementS = get(appStore.draggedElement)

      // No move
      if (
        e.from.dataset.id === e.to.dataset.id &&
        e.newIndex === e.oldIndex &&
        dropElementS.id === 0
      )
        return

      sort.options.sort = false

      // Move from one container to another
      if (e.to.dataset.id !== e.from.dataset.id || dropElementS.id !== 0) {
        let index = e.newIndex
        if (e.to.dataset.id !== e.from.dataset.id) {
          dropElementS.id = parseInt(e.to.dataset.id)
        } else {
          index = -1
        }

        const currentGoals = goalsS.filter(
          (g) => g.parent_goal_id === dropElementS.id
        )
        if (index === -1) index = currentGoals.length

        const currentGoal = goalsS.find((g) => g.id === draggedElementS.id)

        const newGoals: GoalType[] = [
          ...currentGoals.slice(0, index),
          currentGoal,
          ...currentGoals.slice(index)
        ]

        await updateGoalsOrder(newGoals, dropElementS.id)
        sort.options.sort = true
        dropElementS.set({ ...dropElementS, id: 0, type: "" })
        return
      }

      // Same container
      if (e.newIndex !== e.oldIndex) {
        dropElementS.id = parseInt(e.to.dataset.id)
        const currentGoals = goalsS
          .filter((g) => g.parent_goal_id === dropElementS.id)
          .sort((a, b) => a.parent_position - b.parent_position)

        const newGoals = sortElementsForSortable(
          currentGoals,
          e.newIndex,
          e.oldIndex
        ) as GoalType[]

        await updateGoalsOrder(newGoals, dropElementS.id)
        sort.options.sort = true
        dropElementS.set({ ...dropElementS, id: 0, type: "" })
        return
      }
    },
    onStart: (evt: EventSortType) => {
      const dropElementS = get(appStore.dropElement)
      const draggedElementS = get(appStore.draggedElement)

      draggedElementS.set({
        id: parseInt(evt.item.dataset.id),
        type: goalType
      } as draggedElemType)

      dropElementS.set({ id: 0, type: "" } as draggedElemType)
    }
  })
}

export async function duplicateGoal(goal: GoalType): Promise<void> {
  try {
    const offsetY = window.pageYOffset
    const resp = await xhr.post(`/plans/${goal.plan_id}/goals/duplicate.json`, {
      id: goal.id
    })

    const newGoal = resp.data as GoalType
    appStore.goals = [...appStore.goals, newGoal]
    await wait(100)
    window.scrollBy(0, offsetY)
  } catch (e) {
    toast(`There was an error duplicating goal: ${goal.name}`, "error")
  }
}

export async function deleteGoal(goal: GoalType): Promise<void> {
  if (!confirm(`Are you sure you want to delete goal: ${goal.name}`)) return

  try {
    await xhr.delete(`/plans/${goal.plan_id}/goals/${goal.id}.json`)
    appStore.goals = appStore.goals.filter((g) => g.id !== goal.id)
    appStore.tasks = appStore.tasks.filter((t) => t.goal_id !== goal.id)
  } catch (e) {
    toast(`There was an error deleting goal: ${goal.name}`, "error")
  } finally {
  }
}

export async function deleteTask(task: TaskType): Promise<void> {
  if (!confirm(`Are you sure you want to delete task: ${task.name}`)) return

  try {
    await xhr.delete(`/plans/${task.plan_id}/tasks/${task.id}.json`)
    appStore.tasks = appStore.tasks.filter((t) => t.id !== task.id)
  } catch (e) {
    toast("There was an error deleting the task", "error")
  } finally {
  }
}
